<template>
    <div class="page">
        <a-form :model="TGForm" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="formRef">
            <a-form-item label="商品名称" name="title">
                <a-input v-model:value="TGForm.title"/>
            </a-form-item>
            <a-form-item label="商品类型" name="type">
                <select v-model="TGForm.type">
                    <option v-for="(item, i) in subjectData.serviceList" :value="item.name" :key="i">{{ item.value }}</option>
                </select>
            </a-form-item>
            <a-form-item label="商品价格" name="price">
                <a-input-number v-model:value="TGForm.price"/>
            </a-form-item>
            <a-form-item label="产品规格" name="varieties">
                <a-input v-model:value="TGForm.varieties"/>
            </a-form-item>
            <a-form-item label="主体名称" name="publisher">
                <a-input v-model:value="TGForm.publisher"/>
            </a-form-item>
            <a-form-item label="联系电话" name="phone">
                <a-input v-model:value="TGForm.phone"/>
            </a-form-item>
            <a-form-item label="所在镇街" name="towns">
                <select v-model="TGForm.towns" style="width: 100%">
                    <option v-for="(item, i) in this.$utils.townList" :value="item.id" :key="i">{{ item.name }}</option>
                </select>
            </a-form-item>
            <a-form-item label="商品图片">
                <a-upload
                    list-type="picture-card"
                    accept="image/*"
                    :customRequest="handleUploadImage"
                    :multiple=true
                    :remove="handleRemove"
                >
                    <div v-if="fileList2.length < 9">
                        <plus-outlined/>
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-item>
            <a-form-item label="商品描述" name="msg">
                <a-textarea v-model:value="TGForm.msg" :auto-size="{ minRows: 5, maxRows: 8 }"/>
            </a-form-item>
            <div class="add-address">
                <a-button @click="onsubmit">发布</a-button>
            </div>
        </a-form>
    </div>
</template>

<script>
import {reactive, ref, toRaw, onMounted} from "@vue/runtime-dom"
import router from "@/router"
import {notification} from "ant-design-vue"
import {getCommodityTypeApi, saveMallApi} from "@/api/mall"
import {uploadImageApi} from "@/api/directories"
export default {
    name: "AddCommodity",
    setup() {
        const TGForm = reactive({
            title: '',
            type: '',
            price: '',
            varieties: '',
            publisher: '',
            phone: '',
            towns: '',
            msg: '',
        })
        const subjectData = reactive({
            serviceList: [],
        })
        const getToken = async () => {
            const res = await getCommodityTypeApi()
            const list = []
            for (const n in res) {
                list.push({name: n, value: res[n]})
            }
            subjectData.serviceList = list
        }
        const fileList2 = ref([])
        const handleUploadImage = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    fileList2.value.push({id: res.bizId, url: res.url.split('nyfile')[1]})
                    notification.success({message: '上传成功！', duration: 2.5, description: ''})
                    params.onSuccess(res, params.file)
                } else {
                    notification.error({message: '上传失败！', duration: 2.5, description: ''})
                    params.onError()
                }
            }).catch(error => {
                console.error(error)
            })
        }
        const handleRemove = (file) => {
            const id = file.response.bizId
            for (const i in fileList2.value) {
                if (fileList2.value[i].id === id) {
                    fileList2.value.splice(i, 1)
                }
            }
        }
        const formRef = ref()
        const rules = {
            msg: [{required: true, message: '请输入内容', trigger: 'blur'}],
            phone: [{required: true, message: '请输入内容', trigger: 'blur'}],
            varieties: [{required: true, message: '请输入内容', trigger: 'blur'}],
            price: [{required: true, message: '请输入内容', trigger: 'blur', type: 'number'}],
            type: [{required: true, message: '请选择', trigger: 'blur'}],
            towns: [{required: true, message: '请选择', trigger: 'blur'}],
            title: [{required: true, message: '请输入内容', trigger: 'blur'}],
            publisher: [{required: true, message: '请输入内容', trigger: 'blur'}],
        }
        const onsubmit = async () => {
            formRef.value
                .validate()
                .then(() => {
                    let subjectImgs
                    if (fileList2.value.length > 0) {
                        const imgList = []
                        for (const i in fileList2.value) {
                            imgList.push(fileList2.value[i].url)
                        }
                        subjectImgs = imgList.toString() // 图片列表
                    } else {
                        notification.warning({message: '错误！', duration: 2.5, description: '请至少选择一张图片'})
                        return
                    }
                    const value = toRaw(TGForm)
                    const params = {
                        title: value.title,
                        type: value.type,
                        price: value.price,
                        varieties: value.varieties,
                        publisher: value.publisher,
                        phone: value.phone,
                        towns: value.towns,
                        msg: value.msg,
                        imgs: subjectImgs,
                    }
                    saveMallApi(params).then(res => {
                        if (res) {
                            notification.success({ message: '添加成功!', description: '', duration: 2 })
                            setTimeout(() => {
                                router.push({ name: 'Mall'})
                            }, 2000)
                        }
                    })
                })
            .catch(error => {
                console.log('error', error);
            })
        }
        onMounted(() => {
            getToken()
        })
        return {
            TGForm,
            labelCol: {
                span: 6,
            },
            wrapperCol: {
                span: 16,
                offset: 2
            },
            fileList2,
            subjectData,
            formRef,
            rules,
            onsubmit,
            handleUploadImage,
            handleRemove,
        }
    }
}
</script>

<style scoped lang="stylus">
.page {
    width 100%
    height 100%
    background-color #FFF
    padding 10px 35px
    .add-address {
        margin 20px 0
        width 100%
        text-align center
    }
    .add-address >>> .ant-btn {
        width 240px
        background-color #44A73D
        border-color #44A73D
        color #FFF
        border-radius 23px
    }
}
.page >>> .ant-form-item {
    margin-bottom 0
}
@media (max-width: 575px) {
    .page >>> .ant-form-item-label {
        line-height 10.667vw
    }
}
</style>